import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import {finalize} from 'rxjs/operators';

import { NotifierService } from '../ui';
import { FormControl, Validators } from '@angular/forms';
import { isEmpty } from 'lodash';
import { INPIRecord, INPIService } from './inpi.service';

type ViewMode = 'form' | 'searching';

@Component({
  templateUrl: './inpi-home.component.html',
})
export class INPIHomeComponent implements OnInit {

  record: INPIRecord = undefined;

  showHidden: boolean = true;

  mode: ViewMode = 'form'

  siren: FormControl

  @ViewChild('sirenInput')
  sirenInput: ElementRef

  constructor(
    private inpiService: INPIService,
    private notifier: NotifierService,
  ) { }

  ngOnInit() {
    // siren
    this.siren = new FormControl('', [
      Validators.required
    ]);

    // Focus siren input
    this.sirenInput.nativeElement.focus();
  }

  submit() {
    
    if (!this.valid) {
      return;
    }

    this.mode = 'searching';
    this.record = null;

    let notifier = this.notifier;

    notifier.updateProgress(20);

    function onComplete() {
      notifier.endProgress();
    }

    this.inpiService
      .findBySiren(this.siren.value).pipe(
      finalize(onComplete))
      .subscribe((record) => {
        this.record = record;

        this.mode = 'form';
      }, () => {
        this.mode = 'form';
        this.record = undefined;
      });
  }

  get valid() {
    if (this.mode !== 'form') {
      return false;
    }

    let siren = this.siren.value;

    if (isEmpty(siren) || isEmpty(siren.trim())) {
      return false;
    }
    
    return true;
  }
}
